import { ApplicationConfig, isDevMode } from '@angular/core';
import { provideRouter, RouteReuseStrategy, withDebugTracing, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AuthInterceptor, NoReuseStrategy } from "./_shared/helpers";
import { TranslocoHttpLoader } from './transloco-loader';
import { provideTransloco } from '@jsverse/transloco';
import { provideAnimations } from "@angular/platform-browser/animations";
import { DatePipe, JsonPipe, registerLocaleData } from "@angular/common";
import localeDe from '@angular/common/locales/de';

registerLocaleData(localeDe);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      // falls du Debug-Tracing brauchst, kannst du hier auch withDebugTracing() ergänzen
      withRouterConfig({ onSameUrlNavigation: 'reload' })
    ),
    provideAnimations(),
    provideHttpClient(withInterceptors([AuthInterceptor])),
    provideTransloco({
      config: {
        availableLangs: ['de', 'en', 'jp'],
        defaultLang: 'de',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader
    }),
    DatePipe,
    JsonPipe,

    // Custom RouteReuseStrategy
    { provide: RouteReuseStrategy, useClass: NoReuseStrategy }
  ]
};
